import { withEmptyOption } from '@app/modules/social-export/components/helpers/SelectOptions';
import { SelectElementWithLoading } from '@app/modules/social-export/components/inputs/SelectElementWithLoading';
import { socialExport } from '@mi-front/api-clients';
import { FormattedMessage } from 'react-intl';

type Props = {
  stationId: string;
};

export function YoutubeCategoryField({ stationId }: Props) {
  const categoriesQuery = socialExport.useGetYoutubeCategories(stationId);

  const categoryOptions =
    categoriesQuery.data?.map((category: socialExport.YoutubeCategoryDto) => ({
      id: category.id,
      label: category.title,
    })) ?? [];

  const options = withEmptyOption(categoryOptions);

  return (
    <SelectElementWithLoading
      name="categoryId"
      label={<FormattedMessage id="socialExport.youtube.category" defaultMessage="Categoría" />}
      options={options}
      fullWidth
      isLoading={categoriesQuery.isLoading}
    />
  );
}
